/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { IContactLogConfig } from 'app/core/models/essette-interfaces';

@autoinject()
export class ManageContactLogPage {

    ////****************** Fields and Properties ************************************////
    protected config: IContactLogConfig = {
        serviceRootUrl: 'um/auths',
        targetType: 'UM.Auth',
        moduleCode: 'UM'
    };

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly logger: AppLogger) {
        this.logger.source = this;
    }

    ////****************** Element References ***************************************////

    ////****************** Functions ************************************************////

}
